const Colors = {
  // New brand palette
  brandCyan: '#00B9E6',

  // Light tints
  sky100: '#A5E1FA',
  sky200: '#92BBD4',

  // Navy scale (lighter → darker)
  navy300: '#0E719C',
  navy400: '#254F72',
  navy450: '#275880', // our main darker interact color
  navy500: '#1D3E59',
  navy525: '#142A3C',
  navy550: '#1B3245',
  navy575: '#184565',
  navy700: '#113853',
  navy800: '#102332',
  navy850: '#0A1C2A',
  navy850Alt: '#0A1C2B',
  navy900: '#08141F',

  coral500: '#DA4D60',
  warningYellow: '#FFF5E1',

  // Original colors / palette
  black: '#000000',
  white: '#FFFFFF',
  gray: '#646464',
  darkGray: '#474747',
  darkGrayLogo: '#231f20',
  lightGray: '#A9A9A9',
  lighterGray: '#F4F4F4',
  evenLighterGray: '#F9F9F9',
  lightRed: '#F692B1',
  lighterRed: '#FFD3D3',
  red: '#DA4D60', // '#E21755', original red
  darkRed: '#FF3838',
  darkerRed: '#A31212',
  priorityRed: '#DA4D60',
  transparent: 'rgba(0, 0, 0, 0)',
  blue: '#275880', // '#0069FF', // original blue
  lightBlue: 'rgba(0, 105, 255, 0.2)',
  lighterBlue: 'rgba(0, 105, 255, 0.15)',
  toastBlue: '#3f5dbf',

  iosBlue: 'rgb(49, 118, 255)',

  // Note: If you change this, also change the UIColor inside AppDelegate.m (rootView.backgroundColor)
  mainBackground: '#FFFFFF',
  statusBar: 'rgba(255, 255, 255, 0.8)',

  tabBarBlue: '#007AFF',
  pendingYellow: '#FEDF00',
  alertYellow: 'rgb(255, 174, 0)',

  green: '#4CD964',
  greenLight: '#E0F8E0',
  darkGreen: '#117000',

  bottomNavigationBorder: '#EBEBEB',
  linkText: '#0E719C',
  linkTextDisabled: '#C5C5C5',

  brandPrimary: '#275880', // '#2E3192',
  brandSecondary: '#00A79D',

  buttonBackground: '#0069FF',
  buttonBackgroundDisabled: '#F3F3F3',
  buttonText: '#FFFFFF',
  buttonTextDisabled: '#9B9B9B',

  caseListItemBorder: '#c2bcbc',

  chatListItemBackground: '#FFFFFF',
  chatListItemBorder: '#EBEBEB',
  chatListItemBorderLight: '#EFEFEF',

  chatAreaBackground: '#F1F1F1',
  chatItemBackground: '#FFFFFF',
  chatItemBackgroundSelf: '#254F72',
  chatItemBorder: '#EBEBEB',
  chatItemBorderSelf: '#254F72',

  lineButtonBackground: '#FFFFFF',
  lineButtonBorder: '#EBEBEB',

  contactListItemBackground: '#FFFFFF',

  errorDarkRed: '#C33241',

  walkthroughTitle: '#000000',
  walkthroughDescription: '#646464',

  formLabel: '#646464',
  formError: '#E21755',
  textInputText: '#000000',
  textInputTextDisabled: 'rgba(0, 0, 0, 0.4)',
  textInputPlaceholder: '#9B9B9B',
  textInputBorderBottom: '#9B9B9B',
  fakeTextInputBorderBottom: '#D7D7D7',

  text: 'rgb(3, 3, 3)',

  transparentBlack: 'rgba(0, 0, 0, 0.7)',
  transparentRed: 'rgba(255, 0, 0, 0.8)',
  transparentYellow: 'rgba(255, 192, 0, 0.8)',
  transparentWhite: 'rgba(255, 255, 255, 0.7)',
  transparentBlue: 'rgba(49, 118, 255, 0.4)',
};

export default Colors;
